import * as v from 'valibot';

const envSchema = v.looseObject({
	VITE_API_URL: v.pipe(v.string(), v.url()),
	VITE_USE_MOCKS: v.pipe(
		v.optional(v.string()),
		v.transform((s) => s === 'true'),
	),
	VITE_IDP_CLIENT_ID: v.string(),
	VITE_IDP_URL: v.pipe(v.string(), v.url()),
	DEV: v.boolean(),
	PROD: v.boolean(),
});

type Env = v.InferOutput<typeof envSchema>;

export const env: Env = v.parse(envSchema, import.meta.env);
export default env;
